import Immutable from 'immutable';
import {
  GET_INCIDENTS_FOR_FORM,
  FLAG_GETTING_INCIDENTS_FOR_FORM,
  CLEAR_INCIDENTS_FOR_FORM
} from '../../../actions/types/supervision-control';

const INITIAL_STATE = Immutable.Map({
  incidentForForm: Immutable.Map({
    content: Immutable.Map(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_INCIDENTS_FOR_FORM:
      return state.setIn(['incidentForForm', 'content'], Immutable.fromJS(action.payload));
    case CLEAR_INCIDENTS_FOR_FORM:
      return state.setIn(['incidentForForm', 'content'], Immutable.Map());
    case FLAG_GETTING_INCIDENTS_FOR_FORM:
      return state.setIn(['incidentForForm', 'loading'], action.payload);
    default:
      return state;
  }
}

